module.exports = __webpack_public_path__ + "img/bankIdNo.e41e3646.svg";